// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

import { message } from 'antd'
import * as JobApi from 'api/jobs'
import { DOWNLOAD_TASK_TYPE } from '../constants'
import moment from 'moment'
import { getPolygonBBox } from 'utils/bbox'
import { JobStatus, TaskStatus } from 'constants/job'

export const jobList = {
  state: {
    list: [],
    pagination: {
      pageSize: 10,
      total: 0,
      current: 1
    },
    tasks: [],
    paginationTasks: {
      pageSize: 10,
      total: 0,
      current: 1
    },
    loading: false,
    modifyLoading: false,
    isEditModalVisible: false,
    editingJob: null,
    filters: {
      jobType: [],
      jobName: '',
      creatorPlatform: undefined,
      photoDirection: [0],
      deviceType: [],
      // status: [0],
    },
    pausingJobID: null,
    resumingJobID: null
  },
  reducers: {
    setLoading (state, payload) {
      return {
        ...state,
        loading: payload
      }
    },
    replaceList (state, payload) {
      return {
        ...state,
        list: payload.jobs,
        pagination: {
          pageSize: payload.pageSize || 10,
          total: payload.total,
          current: payload.current || 1
        }
      }
    },
    replaceTasks (state, payload) {
      return {
        ...state,
        tasks: payload.tasks,
        paginationTasks: {
          pageSize: payload.pageSize || 10,
          total: payload.total,
          current: payload.current || 1
        }
      }
    },
    deleteJobLocal (state, jobID) {
      const list = state.list
      const deleteAt = list.findIndex(d => d.jobID === jobID)
      list.splice(deleteAt, 1)
      return {
        ...state,
        list: list.slice()
      }
    },
    modifyJobLocal (state, job) {
      const list = state.list
      const dataAt = list.findIndex(d => d.jobID === job.jobID)
      list.splice(dataAt, 1, job)
      return {
        ...state,
        list: list.slice()
      }
    },
    modifyTaskLocal (state, task) {
      const tasks = state.tasks
      const dataAt = tasks.findIndex(d => d.taskID === task.taskID)
      tasks.splice(dataAt, 1, task)
      return {
        ...state,
        tasks: tasks.slice()
      }
    },
    setPagination (state, payload) {
      return {
        ...state,
        pagination: {
          ...state.pagination,
          ...payload
          // current: payload.current,
          // pageSize: payload.pageSize
        }
      }
    },
    setPaginationTasks (state, payload) {
      return {
        ...state,
        paginationTasks: {
          ...state.paginationTasks,
          current: payload.current,
          pageSize: payload.pageSize
        }
      }
    },
    setModifyLoading (state, payload) {
      return {
        ...state,
        modifyLoading: payload
      }
    },
    setEditModalVisible (state, payload) {
      return {
        ...state,
        isEditModalVisible: payload
      }
    },
    setEditingJob (state, job) {
      return {
        ...state,
        editingJob: job
      }
    },
    setFilters (state, payload) {
      return {
        ...state,
        filters: { ...state.filters, ...payload }
      }
    },
    resetFilters (state, payload) {
      return {
        ...state,
        filters: {
          ...payload,
          jobType: [],
          deviceType: [],
          // status: [0],
        }
      }
    },
    setPausingJobID (state, jobID) {
      return {
        ...state,
        pausingJobID: jobID
      }
    },
    setResumingJobID (state, jobID) {
      return {
        ...state,
        resumingJobID: jobID
      }
    }
  },
  effects: dispatch => ({
    async fetchJobs (query, rootState) {
      this.setLoading(true)
      if (query.filters) {
        if (query.filters.jobType === -1) {
          delete query.filters.jobType
        }
        if (query.filters.status === -1) {
          delete query.filters.status
        }
      }
      if (!rootState.city.current) {
        return
      }
      query.cityID = query.cityID || rootState.city.current.id
      try {
        const res = await JobApi.getDownloadJobs(query)
        if (res) {
          this.replaceList(res)
        }
      } catch (error) {
        message.info(`Fetch Jobs Fail ${error}`)
      } finally {
        this.setLoading(false)
      }
    },
    async deleteJob (jobID) {
      try {
        await JobApi.deleteJob(jobID)
        await this.deleteJobLocal(jobID)
        message.success('Delete success')
      } catch (error) {
        message.info(`Delete Failed ${error}`)
      }
    },
    async modifyJob (job) {
      this.setModifyLoading(true)
      try {
        await JobApi.modifyJob({
          jobID: job.jobID,
          startTime: job.startTime,
          startDate: job.startDate,
          endTime: job.endTime === '24:00:00' ? '23:59:59' : job.endTime,
          endDate: job.endDate
        })
        this.modfiyJobLocal({
          ...job
          // startDate: moment(job.startDate)
          //   .utc()
          //   .format(),
          // endDate: moment(job.endDate)
          //   .utc()
          //   .format(),
          // startTime: `0000-01-01T${job.startTime}Z`,
          // endTime: `0000-01-01T${job.endTime}Z`
        })
        message.success('Modify success')
      } catch (error) {
        message.info(`Modify Failed ${error}`)
      } finally {
        this.setModifyLoading(false)
        this.setEditModalVisible(false)
      }
    },
    async processEditingJob (record, rootState) {
      const job = {
        ...record,
        startTime: moment(record.startTime, 'HH:mm:ss'),
        startDate: moment(record.startDate),
        endTime: moment(record.endTime, 'HH:mm:ss'),
        endDate: moment(record.endDate)
      }
      try {
        dispatch.city.setCityStatus(true)
        const geo = await JobApi.getJobGeo(record.jobID)
        let coord
        let bounds
        let camera
        let deviceID
        let deviceGeo: JobApi.IDeviceGeoItem
        switch (record.jobType) {
          case DOWNLOAD_TASK_TYPE.ROAD:
            job.deviceID = null
            job.roadCoordinates = createFeature('LineString', geo, { roadID: record.roadID }, { id: record.roadID })
            dispatch.road.updateRoads([job.roadCoordinates])
            coord = job.roadCoordinates.geometry.coordinates
            bounds = [coord[0], coord[coord.length - 1]]
            dispatch.map.setFitBounds({
              fitBounds: bounds,
              fitBoundsOptions: { padding: 50 }
            })
            break
          case DOWNLOAD_TASK_TYPE.GEOFENCE:
            job.deviceID = null
            job.geoFence = createFeature('Polygon', [geo], {}, { id: record.jobID })
            dispatch.geofence.replaceSelectEnable({
              list: [job.geoFence],
              needRefresh: true
            })
            coord = job.geoFence.geometry.coordinates[0]
            bounds = getPolygonBBox(coord)
            dispatch.map.setFitBounds({
              fitBounds: bounds,
              fitBoundsOptions: { padding: 50 }
            })
            break
          case DOWNLOAD_TASK_TYPE.DEVICE:
            deviceID = record.deviceID
            deviceGeo = geo[0] as JobApi.IDeviceGeoItem
            camera = {
              deviceID: deviceID,
              lat: deviceGeo.latitude,
              lon: deviceGeo.longitude,
              longitude: deviceGeo.longitude,
              latitude: deviceGeo.latitude
            }
            dispatch.cameraFinder.setFilter({deviceID})
            dispatch.map.setViewport({
              center: [deviceGeo.longitude, deviceGeo.latitude],
              zoom: [14]
            })
            dispatch.cameras.updateHoveredCamera(camera)
            // dispatch.cameras.updateCityCameras([camera])
            const cameraDetail = await dispatch.cameras.fetchCameraDetails({ deviceID: deviceID })
            dispatch.cameras.updateHoveredCamera({
              ...cameraDetail,
              lat: cameraDetail.latitude,
              lon: cameraDetail.longitude
            })
            camera = {
              ...cameraDetail,
              ...camera
            }
            dispatch.cameras.updateCityCameras([camera])

            break
          default:
            break
        }
        dispatch.download.changeTaskType(record.jobType)
        dispatch.download.setEditingTask(job)
      } catch (error) {
        console.log(error)
        throw error
      }
    },
    async pauseJob (job: JobApi.IJob, state) {
      this.setPausingJobID(job.jobID)
      try {
        await JobApi.pauseJob(job.jobID)
        this.modfiyJobLocal({
          ...job,
          status: JobStatus.Paused
        })
      } catch (error) {
        throw error
      } finally {
        this.setPausingJobID(null)
      }
    },
    async resumeJob (job: JobApi.IJob, state) {
      this.setResumingJobID(job.jobID)
      try {
        await JobApi.resumeJob(job.jobID)
      } catch (error) {
        throw error
      } finally {
        this.setResumingJobID(null)
      }
    },
    async fetchTasks (query, state) {
      // this.setLoading(true)
      try {
        const res = await JobApi.getTasks(query)
        if (res) {
          this.replaceTasks(res)
        }
      } catch (error) {
        message.info(`Fetch Tasks Fail ${error}`)
      } finally {
        // this.setLoading(false)
      }
    },
    async stopJob (job: JobApi.IJob, state) {
      // this.setPausingJobID(job.jobID)
      try {
        await JobApi.stopJob(job.jobID)
        message.success('Stop success')
        // this.modifyJobLocal({
        //   ...job,
        //   status: JobStatus.Stopped
        // })
      } catch (error) {
        throw error
      } finally {
        // this.setPausingJobID(null)
      }
    },
    async stopTask ({ job, task }, state) {
      try {
        await JobApi.stopTask(job.jobID, task.taskID)
        message.success('Stop success')
        this.modifyTaskLocal({
          ...task,
          status: TaskStatus.Stopped
        })
      } catch (error) {
        throw error
      } finally {
      }
    }
  })
}

function createFeature (type, coords, properties, options) {
  const feature = {
    type: 'Feature',
    properties,
    geometry: {
      type: type,
      coordinates: coords
    }
  }
  return { ...feature, ...options }
}
